export const TimeToWaitBeforeLogging = 10000;

export const DECLINED_PRIVACY_NOTICE = 'Accept the Privacy Notice is to use EY Empowerment';
export const USER_PROFILE_NOT_COMPLETED = 'Completing the user profile is obligatory to use Empowerment';
